<template>
  <div class="language-switch">
    <button @click="changeLanguage('de-de')" :class="(currentLanguage == 'de-de' ? 'active' : '')"><img src="/images/de-de.svg" /></button>
    <button @click="changeLanguage('en-gb')" :class="(currentLanguage == 'en-gb' ? 'active' : '')"><img src="/images/en-gb.svg" /></button>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'LanguageSwitch',
  created () {
    this.currentLanguage = window.KriensTourismus.language
    this.getLanguageKeys()
  },
  data () {
    return {
      currentLanguage: null
    }
  },
  methods: {
    async changeLanguage (language) {
      EventBus.$emit(EventBus.constants.LANGUAGE_CHANGED, language)
      this.currentLanguage = language
      window.KriensTourismus.language = language
      this.getLanguageKeys(language)
    },
    async getLanguageKeys(language = window.KriensTourismus.language) {
      let document = await this.$prismic.client.getSingle('languagekeys', {lang: language})
      if (document.data.languageitem) {
        let languageKeyArray = document.data.languageitem
        this.KriensTourismus.languageKeys = this.parseLanguageKeyArray(languageKeyArray)
      }
    },
    parseLanguageKeyArray(languageKeyArray) {
      let languageKeyObject = {}
      for (let languageItem of languageKeyArray) {
        languageKeyObject[languageItem.key] = languageItem.content
      }
      return languageKeyObject
    }
  }
}
</script>